module.exports = __webpack_public_path__ + "img/scroll02.8936d35.png";